import styled from 'styled-components';

/* Candidate thumbnail images */
const CandidateImage = styled.div`
  display: none;

   /* ----- Card with photo — hide on mobile ----- */
  .election-hub--race-card__with-photos & {
    display: none;

    @media screen and (min-width: ${(props) => props.theme.md}) {
      display: inline-block;
    }

    /* ----- Small-width Hub ----- */
    .election-hub--min & {
      display: none;
    }
  }

  img {
    height: ${(props) => props.theme.imgHeight};
    min-width: ${(props) => props.theme.imgHeight};
    object-fit: cover;
    object-position: center center;
    width: ${(props) => props.theme.imgHeight};
    vertical-align: middle;
  }
`;

/* Candidate party text */
const CandidateParty = styled.div`
  color: ${(props) => props.theme.black};
  display: inline-block;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1;
  margin: -0.0625rem 0 0 0.25rem;

  &::before {
    content: '/ ';
  }

  span {
    display: inline-block;
  }

  @media screen and (min-width: ${(props) => props.theme.md}) {
    font-size: 0.85rem;
  }

  /* ----- Small-width Hub ----- */
    .election-hub--min & {
    font-size: 0.75rem;
  }

  /* ----- Mobile Only ----- */
  .election-hub--mobile {
    display: inline-block;

    @media screen and (min-width: ${(props) => props.theme.md}) {
      display: none;
    }

    /* ----- Large-width Hub ----- */
    .election-hub--main & {
      display: none;
    }

    /* ----- Large-width Hub ----- */
    .election-hub--min & {
      display: inline-block;
    }
  }

  /* ----- Desktop Only ----- */
  .election-hub--desktop {
    display: none;
    text-transform: initial;

    @media screen and (min-width: ${(props) => props.theme.md}) {
      display: inline-block;
    }

    /* ----- Large-width Hub ----- */
    .election-hub--min & {
      display: none;
    }
  }
`;

const CandidateInfoWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0 0 0 1.125rem;
`;

export default {
  CandidateImage,
  CandidateParty,
  CandidateInfoWrap,
};
